import type {
  StudentMe,
  StudentProfileFormValues,
  UpdateStudentMeRequest,
} from './types';

export function unwrapStudentMe(response: unknown): StudentMe {
  if (response && typeof response === 'object' && 'data' in response) {
    const envelope = response as { data?: StudentMe };
    if (envelope.data && typeof envelope.data === 'object') {
      return envelope.data;
    }
  }
  return response as StudentMe;
}

export function toStudentProfileFormValues(
  student: StudentMe | null | undefined,
): StudentProfileFormValues {
  const profile = student?.profile;
  return {
    displayName: profile?.displayName ?? '',
    bio: profile?.bio ?? '',
    goals: profile?.goals ?? '',
    introVideoUrl: profile?.introVideoUrl ?? '',
    avatarUrl: profile?.avatarUrl ?? '',
    timezone: profile?.timezone ?? '',
    nativeLanguages: profile?.nativeLanguages ?? [],
    categoryIds: (student?.categoryIds ?? []).map(String),
  };
}

export function toUpdateStudentMeRequest(
  values: StudentProfileFormValues,
): UpdateStudentMeRequest {
  return {
    profile: {
      displayName: values.displayName.trim(),
      bio: values.bio.trim() || null,
      goals: values.goals.trim() || null,
      introVideoUrl: values.introVideoUrl.trim() || null,
      avatarUrl: values.avatarUrl.trim() || null,
      timezone: values.timezone.trim() || null,
      nativeLanguages: values.nativeLanguages,
    },
    categoryIds: values.categoryIds
      .map((id) => Number(id))
      .filter((id) => Number.isInteger(id)),
  };
}
